import React from 'react'
import { makeStyles, IconButton, Grid } from '@paintscout/ui'
import ClearIcon from '@material-ui/icons/Clear'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft'
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight'

const useStyles = makeStyles({
  root: {},
  buttonWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'center',
    minWidth: 43 // as close to 48 (24 for button and 12 padding) while still displaying inline when needed
  },
  buttonWrapperHorizontal: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
  moveRemoveButton: {
    padding: 0,
    height: 24,
    width: 24
  },
  removeButton: {
    margin: '8px 0'
  },
  removeButtonHorizontal: {
    margin: '0 8px'
  }
})

interface MoveRemoveButtonProps {
  arrayHelpers: any
  index: number
  section: any
  /**
   * Render the controls as a horizontal `< ✕ >` row (left/remove/right) instead of the
   * default vertical `^ ✕ v` column. Used by forms that tuck the mover under another field.
   */
  horizontal?: boolean
}

export function MoveRemoveButtons({ arrayHelpers, index, section, horizontal, ...props }: MoveRemoveButtonProps) {
  const classes = useStyles(props)

  const isLast = index === section?.fields?.rows.length - 1

  if (horizontal) {
    return (
      <div className={classes.buttonWrapperHorizontal}>
        <IconButton
          onClick={() => {
            arrayHelpers.move(index, index - 1)
          }}
          classes={{ root: classes.moveRemoveButton }}
          disabled={index === 0}
        >
          <KeyboardArrowLeftIcon />
        </IconButton>
        <IconButton
          onClick={() => {
            arrayHelpers.remove(index)
          }}
          classes={{ root: `${classes.moveRemoveButton} ${classes.removeButtonHorizontal}` }}
        >
          <ClearIcon />
        </IconButton>
        <IconButton
          onClick={() => {
            arrayHelpers.move(index, index + 1)
          }}
          classes={{ root: classes.moveRemoveButton }}
          disabled={isLast}
        >
          <KeyboardArrowRightIcon />
        </IconButton>
      </div>
    )
  }

  return (
    <Grid item xs={1} className={classes.buttonWrapper}>
      <IconButton
        onClick={() => {
          arrayHelpers.move(index, index - 1)
        }}
        classes={{ root: classes.moveRemoveButton }}
        disabled={index === 0}
      >
        <KeyboardArrowUpIcon />
      </IconButton>
      <IconButton
        onClick={() => {
          arrayHelpers.remove(index)
        }}
        classes={{ root: `${classes.moveRemoveButton} ${classes.removeButton}` }}
      >
        <ClearIcon />
      </IconButton>
      <IconButton
        onClick={() => {
          arrayHelpers.move(index, index + 1)
        }}
        classes={{ root: classes.moveRemoveButton }}
        disabled={isLast}
      >
        <KeyboardArrowDownIcon />
      </IconButton>
    </Grid>
  )
}
